/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./generic-column.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./generic-column.component";
var styles_GenericColumnComponent = [i0.styles];
var RenderType_GenericColumnComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_GenericColumnComponent, data: {} });
export { RenderType_GenericColumnComponent as RenderType_GenericColumnComponent };
export function View_GenericColumnComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_GenericColumnComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 16777216, null, null, 1, "app-generic-column", [], null, null, null, View_GenericColumnComponent_0, RenderType_GenericColumnComponent)), i1.ɵdid(1, 114688, null, 0, i2.GenericColumnComponent, [i1.ComponentFactoryResolver, i1.ViewContainerRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var GenericColumnComponentNgFactory = i1.ɵccf("app-generic-column", i2.GenericColumnComponent, View_GenericColumnComponent_Host_0, { node: "node", entity: "entity", component: "component", column: "column" }, {}, []);
export { GenericColumnComponentNgFactory as GenericColumnComponentNgFactory };
